import { useQuery } from '@tanstack/react-query'
import apiClient from '../../api/enrollment-platform-client/api-client'
import { SimpleCustomerDto } from './dto/simple-customer.dto'
import { queryClient } from '../../../containers/AppContainer'
import { getAuthorizationToken } from '../../modules/authorization'

const CLIENTS_STALE_TIME = 3 * 60 * 1000

export const fetchClients = async (): Promise<SimpleCustomerDto[]> => {
  const url = 'members/me/administered-customers'
  const response = await apiClient.get<SimpleCustomerDto[]>(url)
  return response.data.filter((c) => c.isActive)
}

export const getMyClients = async (): Promise<SimpleCustomerDto[]> => {
  const idToken = getAuthorizationToken()
  return queryClient.fetchQuery({
    queryKey: ['administered-customers', idToken],
    queryFn: fetchClients,
    staleTime: CLIENTS_STALE_TIME,
  })
}

export const useMyClientsQuery = () => {
  return useQuery<SimpleCustomerDto[]>({
    queryKey: ['administered-customers'],
    queryFn: fetchClients,
    staleTime: CLIENTS_STALE_TIME,
  })
}
